<template>
  <div style="margin-top:10px;background:#fff;overflow: hidden;border-radius: 5px;padding: 10px;">
    <a-table :columns="columns" :data-source="data" :rowKey='record=>record.id' bordered :pagination="false">
      <span slot="auth" slot-scope="text, record">
        <a-tag color="#2db7f5" v-for="(item, index) in record.permKeys.split(',')" :key="index">
          {{ matchFun.menuNameByCode(item) }}
        </a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <a-button-group size="small" >
          <a-button type="dashed" :disabled="accountId === record.accountId" icon="edit" @click="$refs.authForm.show(record, agencyId)">编辑</a-button>
          <a-popconfirm
            title="确定删除吗?"
            @confirm="() => delAccount(record.accountId)"
          >
            <a-button :disabled="accountId === record.accountId" type="danger" icon="delete">删除</a-button>
          </a-popconfirm>
        </a-button-group>
      </span>
    </a-table>
    <div class="BottomButton">
      <div @click="$refs.authForm.show(null, agencyId)">
        {{$t('添加授权账号')}}
      </div>
    </div>
    <AuthForm ref="authForm" @ok="refreshAuth"/>
  </div>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
import AuthForm from './AuthForm'
import { mapState } from 'vuex'
export default {
  name: 'CenterAuth',
  components: {
    AuthForm
  },
  created () {
    this.initList()
  },
  mounted () {},
  data () {
    return {
      matchFun: matchFun,
      agencyId: this.$route.query.agencyId,
      columns: [{
        title: '昵称',
        dataIndex: 'nickname',
        key: 'nickname',
        align: 'center'
      },
      {
        title: '账号',
        dataIndex: 'account',
        key: 'account',
        align: 'center'
      },
      {
        title: '管理权限',
        key: 'auth',
        dataIndex: 'auth',
        align: 'center',
        scopedSlots: { customRender: 'auth' }
      },
      {
        title: '操作',
        key: 'action',
        align: 'center',
        scopedSlots: { customRender: 'action' }
      }],
      data: []
    }
  },
  computed: {
    ...mapState({
      accountId: state => state.user.accountId
    })
  },
  methods: {
    initList () {
      this.$api.high.personalCenter({agencyId: this.agencyId}).then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    },
    refreshAuth () {
      this.initList()
    },
    delAccount (accountId) {
      if (this.accountId === accountId) {
        this.$message.error('禁止删除自己')
        return
      }
      this.$api.high.delSubaccount({agencyId: this.agencyId, accountId: accountId}).then(res => {
        if (res && res.status === 0) {
          this.initList()
          this.$message.success('操作成功')
        } else {
          this.$message.error(res.msg || '操作失败')
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.BottomButton{
    margin: 50px 0;
    text-align: center;
    div{
        background-color: #d60701;
        padding: 10px 25px;
        width: 160px;
        color: #fff;
        margin: 0 auto;
        border-radius: 2px;
        cursor: pointer;
        text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/center/CenterAuth.vue